// this will be expanded upon to add groups etc, controls role member type select
// current implementation only allows person types
export enum RoleMemberType {
    FoundationApiResource = 1,
    MyKonicaMinoltaPerson = 5,
    MyKonicaMinoltaJobCode = 6,
    MyKonicaMinoltaApplicationGroup = 7,
    MyKonicaMinoltaApplicationEntity = 8,
    MyKmbsPerson = 9
};